import { render, staticRenderFns } from "./LiveFeedEntries.vue?vue&type=template&id=e3e20e7a&"
import script from "./LiveFeedEntries.vue?vue&type=script&lang=ts&"
export * from "./LiveFeedEntries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports